/* KK Cart Update 2 / 3 cart drawer behaviour (kkcu2 = shared namespace).
   - Countdown bar: restarts from N minutes every time the drawer opens
     (same as the reference brand), digits roll like a slot machine.
   - Free-shipping bar / totals / add-on rows are pure Liquid; this file only
     re-inits animations after the theme swaps the drawer HTML.
   - Order Protect ($0) is auto-added as a real cart line as soon as the cart
     holds a real product, removed again when the cart empties, and never
     re-added after the customer unticks it (sessionStorage).
   - Climate Neutral Shipping is customer-driven only.
   - Upsell "+ Add" buttons, "What's Included?" pill, info tooltips (tap). */
(function () {
  'use strict';

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var OPT_OUT_KEY = 'kkcu2_protect_off';
  var syncing = false;
  var pending = false;
  var timerEnd = 0;
  var timerHandle = null;

  function drawerEl() {
    return document.querySelector('cart-drawer.kkcu2');
  }
  function cfg() {
    var d = document.getElementById('CartDrawer');
    if (!d) return null;
    return {
      protectVariant: parseInt(d.dataset.kkcu2ProtectVariant, 10) || 0,
      climateVariant: parseInt(d.dataset.kkcu2ClimateVariant, 10) || 0,
      protectHandle: d.dataset.kkcu2ProtectHandle || '',
      climateHandle: d.dataset.kkcu2ClimateHandle || '',
      minutes: parseInt(d.dataset.kkcu2TimerMinutes, 10) || 8
    };
  }
  function optedOut() {
    try { return sessionStorage.getItem(OPT_OUT_KEY) === '1'; } catch (e) { return false; }
  }
  function setOptOut(v) {
    try { v ? sessionStorage.setItem(OPT_OUT_KEY, '1') : sessionStorage.removeItem(OPT_OUT_KEY); } catch (e) {}
  }
  function isAddon(item, c) {
    return item.variant_id === c.protectVariant || item.variant_id === c.climateVariant;
  }

  /* ---------- cart requests ---------- */
  function getCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function addLine(id, qty) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
    });
  }
  function changeLine(id, qty) {
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: String(id), quantity: qty })
    });
  }
  function setVariantQty(id, qty) {
    return getCart().then(function (cart) {
      var present = cart.items.some(function (i) { return i.variant_id === id; });
      if (present) return changeLine(id, qty);
      if (qty > 0) return addLine(id, qty);
      return null;
    });
  }

  /* Re-render the drawer from a fresh section render. Cart line numbers shift
     when a hidden add-on line is added/removed, so the drawer must always be
     re-fetched after our own mutations (data-index would be stale). */
  function refreshCartUI() {
    return fetch(root + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var drawer = drawerEl();
        if (drawer && sections['cart-drawer']) {
          var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
          var fresh = doc.querySelector('cart-drawer');
          if (fresh) {
            var wasEmpty = drawer.classList.contains('is-empty');
            var nowEmpty = fresh.classList.contains('is-empty');
            drawer.classList.toggle('is-empty', nowEmpty);
            if (wasEmpty !== nowEmpty || !drawer.querySelector('cart-drawer-items')) {
              var inner = drawer.querySelector('.drawer__inner');
              var freshInner = fresh.querySelector('.drawer__inner');
              if (inner && freshInner) inner.innerHTML = freshInner.innerHTML;
            } else {
              ['cart-drawer-items', '.cart-drawer__footer'].forEach(function (sel) {
                var target = drawer.querySelector(sel);
                var source = fresh.querySelector(sel);
                if (target && source) target.replaceWith(source);
                else if (target && !source) target.remove();
              });
            }
          }
        }
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && sections['cart-icon-bubble']) {
          var bdoc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
          var binner = bdoc.querySelector('.shopify-section') || bdoc.body;
          bubble.innerHTML = binner.innerHTML;
        }
      })
      .catch(function () {});
  }

  /* ---------- Order Protect sync ---------- */
  function reconcile() {
    var c = cfg();
    if (!c || !c.protectVariant) return;
    if (syncing) { pending = true; return; }
    syncing = true;
    getCart()
      .then(function (cart) {
        var real = 0, protectQty = 0, climateQty = 0;
        cart.items.forEach(function (item) {
          if (item.variant_id === c.protectVariant) protectQty += item.quantity;
          else if (item.variant_id === c.climateVariant) climateQty += item.quantity;
          else if (item.handle !== 'kitty-belt-buckle') real += item.quantity;
        });
        var ops = [];
        if (real === 0) {
          if (protectQty > 0) ops.push(changeLine(c.protectVariant, 0));
          if (climateQty > 0) ops.push(changeLine(c.climateVariant, 0));
        } else {
          if (protectQty === 0 && !optedOut()) ops.push(addLine(c.protectVariant, 1));
          if (protectQty > 1) ops.push(changeLine(c.protectVariant, 1));
          if (climateQty > 1) ops.push(changeLine(c.climateVariant, 1));
        }
        if (!ops.length) return null;
        return ops.reduce(function (p, op) { return p.then(function () { return op; }); }, Promise.resolve())
          .then(refreshCartUI);
      })
      .catch(function () {})
      .then(function () {
        syncing = false;
        if (pending) { pending = false; reconcile(); }
      });
  }

  var origFetch = window.fetch;
  window.fetch = function () {
    var url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url) || '';
    var result = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      result.then(function () { setTimeout(reconcile, 60); }, function () {});
    }
    return result;
  };

  /* ---------- countdown ---------- */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function setDigit(tile, ch, animate) {
    var cur = tile.querySelector('.is-current');
    if (cur && cur.textContent === ch) return;
    if (!animate || !cur) {
      tile.innerHTML = '<span class="kkcu2-timer__digit is-current">' + ch + '</span>';
      return;
    }
    var next = document.createElement('span');
    next.className = 'kkcu2-timer__digit is-next';
    next.textContent = ch;
    tile.appendChild(next);
    next.getBoundingClientRect(); /* commit start position */
    cur.classList.remove('is-current');
    cur.classList.add('is-past');
    next.classList.remove('is-next');
    next.classList.add('is-current');
    setTimeout(function () { if (cur.parentNode) cur.parentNode.removeChild(cur); }, 600);
  }
  function renderTimer(animate) {
    var el = document.querySelector('[data-kkcu2-timer]');
    if (!el) return;
    var c = cfg();
    var remaining = timerEnd ? Math.max(0, timerEnd - Date.now()) : (c ? c.minutes * 60000 : 0);
    var total = Math.floor(remaining / 1000);
    var h = Math.floor(total / 3600), m = Math.floor((total % 3600) / 60), s = total % 60;
    var str = pad(h) + pad(m) + pad(s);
    var tiles = el.querySelectorAll('.kkcu2-timer__tile');
    for (var i = 0; i < tiles.length && i < 6; i++) setDigit(tiles[i], str.charAt(i), animate);
    var bar = el.closest('[data-kkcu2-timer-bar]');
    if (bar) bar.classList.toggle('is-expired', timerEnd > 0 && remaining === 0);
  }
  function startTimer() {
    var c = cfg();
    if (!c) return;
    timerEnd = Date.now() + c.minutes * 60000;
    renderTimer(false);
    if (timerHandle) clearInterval(timerHandle);
    timerHandle = setInterval(function () {
      renderTimer(true);
      if (timerEnd - Date.now() <= 0) { clearInterval(timerHandle); timerHandle = null; }
    }, 250);
  }

  /* ---------- free-shipping bar in non-shop currencies ----------
     Liquid renders the bar with the threshold in the shop currency. When the
     visitor's presentment currency differs, convert with Shopify.currency.rate
     and rewrite the bar + the SHIPPING row so the numbers match checkout. */
  function moneyFormatter(sample) {
    /* sample = 123456 cents rendered by Liquid, e.g. "1,234.56 RSD" or "$1,234.56" */
    var m = /1(\D?)234(\D)56/.exec(sample || '');
    if (!m) return null;
    var thousands = m[1], decimal = m[2];
    var prefix = sample.slice(0, m.index), suffix = sample.slice(m.index + m[0].length);
    return function (cents, trimZeros) {
      cents = Math.max(0, Math.round(cents));
      var whole = String(Math.floor(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      var frac = pad(cents % 100);
      var num = trimZeros && frac === '00' ? whole : whole + decimal + frac;
      return prefix + num + suffix;
    };
  }
  var CHECK_SVG = '<svg viewBox="0 0 16 16" width="10" height="10" aria-hidden="true"><path d="M3 8.5l3 3 7-7" fill="none" stroke="#fff" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var LOCK_HTML = '<div class="kkcu2-shipbar__lock" aria-hidden="true"><svg viewBox="0 0 8 8" width="8" height="8"><path d="M2.2 3.4V2.6a1.8 1.8 0 013.6 0v.8M1.6 3.4h4.8v3.4H1.6z" fill="none" stroke="#8D8D8D" stroke-width="0.9" stroke-linejoin="round"/><circle cx="4" cy="5.1" r="0.55" fill="#8D8D8D"/></svg></div>';
  function updateShipbar() {
    var bar = document.querySelector('[data-kkcu2-shipbar]');
    if (!bar || bar.dataset.kkcu2Converted) return;
    var cur = window.Shopify && Shopify.currency;
    var shopCurrency = bar.dataset.shopCurrency;
    var active = (cur && cur.active) || bar.dataset.cartCurrency;
    if (!active || active === shopCurrency) return;
    var rate = parseFloat(cur && cur.rate);
    if (!(rate > 0)) return;
    var fmt = moneyFormatter(bar.dataset.moneySample);
    if (!fmt) return;
    /* round UP to a whole unit of the presentment currency: no "₸32,288.54" in the UI and
       the customer is always at/over Shopify's own (unrounded) converted minimum */
    var threshold = Math.ceil(parseInt(bar.dataset.thresholdShopCents, 10) * rate / 100) * 100;
    var subtotal = parseInt(bar.dataset.subtotalCents, 10) || 0;
    if (!(threshold > 0)) return;
    var remaining = threshold - subtotal;
    var unlocked = remaining <= 0;
    var pct = Math.max(0, Math.min(100, Math.round(subtotal * 100 / threshold)));
    bar.dataset.kkcu2Converted = '1';
    bar.classList.toggle('is-unlocked', unlocked);
    var title = bar.querySelector('.kkcu2-shipbar__title');
    if (title) {
      title.innerHTML = unlocked
        ? '🥳 Yaaay! You unlocked <strong>FREE SHIPPING</strong>'
        : '🚚 Spend <strong class="kkcu2-shipbar__amount">' + fmt(remaining, true) + '</strong> more and unlock <strong>FREE SHIPPING</strong>';
    }
    var wrap = bar.querySelector('.kkcu2-shipbar__bar');
    var fill = bar.querySelector('.kkcu2-shipbar__fill');
    var knob = bar.querySelector('.kkcu2-shipbar__knob');
    var lock = bar.querySelector('.kkcu2-shipbar__lock');
    if (wrap) wrap.setAttribute('aria-valuenow', pct);
    if (fill) fill.style.width = pct + '%';
    if (knob) {
      knob.style.left = 'calc(8px + (100% - 16px) * ' + pct + ' / 100)';
      knob.innerHTML = unlocked ? CHECK_SVG : '';
    }
    if (unlocked && lock) lock.remove();
    if (!unlocked && !lock && wrap) wrap.insertAdjacentHTML('beforeend', LOCK_HTML);
    var meta = bar.querySelectorAll('.kkcu2-shipbar__meta span');
    if (meta[0]) meta[0].innerHTML = "You're at <strong>" + fmt(subtotal) + '</strong>';
    if (meta[1]) meta[1].innerHTML = (unlocked ? 'Goal reached: ' : 'Free shipping at ') + '<strong>' + fmt(threshold) + '</strong>';
    var totals = document.querySelector('[data-kkcu2-totals]');
    if (totals) {
      var row = totals.querySelector('.kkcu2-totals__row--shipping');
      var subtotalRow = totals.querySelector('.kkcu2-totals__row--subtotal');
      if (unlocked && !row && subtotalRow) {
        subtotalRow.insertAdjacentHTML('beforebegin', '<div class="kkcu2-totals__row kkcu2-totals__row--shipping"><span>SHIPPING</span><span class="kkcu2-free">🥳 FREE</span></div>');
      } else if (!unlocked && row) {
        row.remove();
      }
    }
  }

  /* ---------- drawer scale ----------
     The Figma frame is 430px wide. The drawer is zoomed by the theme setting
     (default 85%) and, on viewports narrower than 430px, by vw/430 on top, so
     every size keeps the Figma proportions. The CSS width is widened by the
     same factor so the zoomed drawer still fills the screen (or stays 430px
     rendered on desktop). zoom participates in layout, so the scroll container
     keeps working. */
  var DESIGN_WIDTH = 430;
  function applyScale() {
    var drawer = drawerEl();
    var inner = document.querySelector('cart-drawer.kkcu2 .drawer__inner');
    var d = document.getElementById('CartDrawer');
    if (!drawer || !inner || !d) return;
    var shopCurrency = d.dataset.kkcu2ShopCurrency || '';
    var active = window.Shopify && Shopify.currency && Shopify.currency.active;
    drawer.classList.toggle('is-foreign', !!(shopCurrency && active && active !== shopCurrency));

    var setting = parseInt(d.dataset.kkcu2Scale, 10);
    var base = setting > 0 ? Math.min(1, setting / 100) : 1;
    var vw = document.documentElement.clientWidth || window.innerWidth;
    var fit = vw < DESIGN_WIDTH ? vw / DESIGN_WIDTH : 1;
    var zoom = base * fit;
    var rendered = Math.min(vw, DESIGN_WIDTH);
    if (zoom >= 0.999) {
      inner.style.zoom = '';
      inner.style.removeProperty('width');
      inner.style.removeProperty('max-width');
      return;
    }
    inner.style.zoom = String(zoom);
    inner.style.setProperty('width', Math.round(rendered / zoom) + 'px', 'important');
    inner.style.setProperty('max-width', 'none', 'important');
  }

  var resizeHandle = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeHandle);
    resizeHandle = setTimeout(applyScale, 100);
  });

  /* ---------- open / re-render hooks ---------- */
  function onDrawerOpen() {
    startTimer();
    animateCheckout();
    reconcile();
  }
  function animateCheckout() {
    var btn = document.querySelector('.kkcu2-checkout');
    if (!btn) return;
    btn.classList.remove('is-in');
    btn.getBoundingClientRect();
    btn.classList.add('is-in');
    /* drop the entrance class once it has played so nothing can replay it */
    btn.addEventListener('animationend', function onEnd(e) {
      if (e.animationName !== 'kkcu2-move-in-bottom') return;
      btn.classList.remove('is-in');
      btn.removeEventListener('animationend', onEnd);
    });
  }
  var lastActive = false;
  function watchDrawer() {
    var drawer = drawerEl();
    if (!drawer) return;
    lastActive = drawer.classList.contains('active');
    new MutationObserver(function (muts) {
      var active = drawer.classList.contains('active');
      if (active && !lastActive) onDrawerOpen();
      lastActive = active;
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].type === 'childList') { scheduleReinit(); break; }
      }
    }).observe(drawer, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
    if (lastActive) onDrawerOpen();
  }
  var reinitHandle = null;
  function scheduleReinit() {
    if (reinitHandle) return;
    reinitHandle = setTimeout(function () {
      reinitHandle = null;
      applyScale();
      renderTimer(false);
      updateShipbar();
    }, 30);
  }

  /* ---------- delegated clicks ---------- */
  document.addEventListener('click', function (e) {
    var info = e.target.closest('[data-kkcu2-info]');
    if (info) {
      e.preventDefault();
      e.stopPropagation();
      var open = info.classList.contains('is-open');
      document.querySelectorAll('[data-kkcu2-info].is-open').forEach(function (n) { n.classList.remove('is-open'); });
      if (!open) info.classList.add('is-open');
      return;
    }
    document.querySelectorAll('[data-kkcu2-info].is-open').forEach(function (n) { n.classList.remove('is-open'); });

    var incl = e.target.closest('[data-kkcu2-included]');
    if (incl) {
      e.preventDefault();
      var item = incl.closest('.cart-item-mobile-view');
      var toggle = item && item.querySelector('.cart-item-view__variant-toggle');
      if (toggle) toggle.click();
      return;
    }

    var add = e.target.closest('[data-kkcu2-upsell-add]');
    if (add) {
      e.preventDefault();
      if (add.classList.contains('is-loading')) return;
      add.classList.add('is-loading');
      var id = parseInt(add.dataset.kkcu2UpsellAdd, 10);
      addLine(id, 1)
        .then(function (r) { if (!r.ok) throw new Error('add failed'); })
        .then(refreshCartUI)
        .catch(function () { add.classList.remove('is-loading'); });
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-kkcu2-addon-input]');
    if (!input) return;
    var label = input.closest('[data-kkcu2-addon]');
    var type = label ? label.dataset.kkcu2Addon : '';
    var id = parseInt(input.dataset.variantId, 10);
    var on = input.checked;
    if (label) { label.classList.toggle('is-checked', on); label.classList.add('is-loading'); }
    if (type === 'protect') setOptOut(!on);
    setVariantQty(id, on ? 1 : 0)
      .then(refreshCartUI)
      .catch(function () { if (label) label.classList.remove('is-loading'); });
  });

  function init() {
    watchDrawer();
    applyScale();
    renderTimer(false);
    updateShipbar();
    reconcile();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
